export default {"src":"/_next/static/media/arrow_up.ff2ca591.svg","height":7,"width":10,"blurWidth":0,"blurHeight":0};